import React, { useContext, useRef } from "react";
import Button from "@/components/ui/Button.jsx";
import "rc-slider/assets/index.css";
import Card from "@/components/ui/Card.jsx";
import ModelSettings from "@/pages/chatbot/settings/ModelSettings";
import { useTranslation } from "react-i18next";
import { saveSettings } from "@/store/chatbot.ts";
import { ChatbotContext } from "@/store/context/ChatbotContext.tsx";
import { useParams } from "react-router-dom";

export interface RateLimits {
  message: string;
  dailyLimit: number;
  limit: number;
  period: number;
}

export interface Leads {
  message: string;
  fields: any[];
}

const ChatBotAiSettings = () => {
  const { t } = useTranslation();
  const { chatbotID } = useParams();
  const { chatSettings, setSettings, viewChatbot, invalidateChatbot } =
    useContext(ChatbotContext);

  if (!chatSettings || !viewChatbot) {
    return <div>Loading...</div>;
  }

  return (
    <div className="relative">
      <Card title={t("settings")}>
        <ModelSettings
          viewSettings={chatSettings}
          viewChatbot={viewChatbot}
          setSettings={setSettings}
        />

        <div className="flex justify-end mt-6">
          {/*@ts-ignore*/}
          <Button
            text={t("save_changes")}
            className="btn-outline-primary"
            onClick={async () => {
              if (chatbotID) {
                await saveSettings(chatbotID, chatSettings, invalidateChatbot);
              }
            }}
          />
        </div>
      </Card>
    </div>
  );
};

export default ChatBotAiSettings;
